module.exports = __webpack_public_path__ + "static/media/subOutlook3.72bf389a.png";